import { _ } from "libs";

import React from "react";
import ClubWeather from "./clubWeather";
import { Club, Weather } from "../../types";
import GCDayPicker from "../gcDayPicker";
import moment from "moment-timezone";
import { getZonedTime } from "../../libs/time";
import FavoriteStar from "./favoriteStar";

const ClubHeader = ({
	club,
	weather,
	onTimeChange,
	favoriteClub,
	unfavoriteClub,
	timestamp,
	widgetMode,
}: {
	club: Club;
	weather: Weather;
	onTimeChange: (timestamp: number) => void;
	favoriteClub: any;
	unfavoriteClub: any;
	timestamp: number;
	widgetMode?: boolean;
}) => {
	const timezone = club.clubInfo.timeZone;

	const time = moment.unix(timestamp).startOf("hour").tz(timezone);

	const day = time.clone().startOf("day").format("YYYY-MM-DD");

	const onDayChange = (day: string) => {
		const timestamp = getZonedTime(day, timezone).unix();
		onTimeChange(timestamp);
	};

	return (
		<div className="clubHeader">
			{!widgetMode ? (
				<div className="clubTitle">
					<div className="clubName">
						{club.clubInfo.name}
						<FavoriteStar club={club} favoriteClub={favoriteClub} unfavoriteClub={unfavoriteClub} />
					</div>
					{club.clubDetails.type != null ? (
						<div className="clubType">{_("club." + club.clubDetails.type)}</div>
					) : (
						<div className="clubType">{_("club.nonContracted")}</div>
					)}
				</div>
			) : null}

			{weather !== null ? <ClubWeather weather={weather} /> : null}
			<div className="clubDatePicker">
				<GCDayPicker
					value={day}
					onChange={onDayChange}
					timezone={timezone}
					daysAhead={club.clubDetails.maxDaysInAdvance ?? 30}
				/>
			</div>
		</div>
	);
};
export default ClubHeader;
